import _ from 'lodash'
import qs from 'querystring'

import Vue from 'vue'

export function m (component) {
  return {
    create (props, options = {}) {
      const node = document.createElement('div')
      document.body.appendChild(node)

      let vm = new Vue({
        el: node,
        data () {
          return {props}
        },
        render: h => h(component, {props})
      })
      // let ins = vm.$mount()
      // document.body.appendChild(vm.$el)

      const close = () => {
        document.body.removeChild(vm.$el)
        vm.$destroy()
      }

      if (options.autoClose === true) {
        setTimeout(() => {
          close()
        }, options.timeout || 3000)
      }

      return {
        vm,
        close
      }
    }
  }
}

let sizeCap = 1024
function parseSize (size, time = 0) {
  if (size < sizeCap) {
    return [size.toFixed(2), time]
  }
  return parseSize(size / sizeCap, ++time)
}
export function formatSize (size = 0) {
  if (typeof size !== 'number') {
    return ''
  }
  let [sizeFixed, time] = parseSize(size)
  switch (time) {
    case 0:
      return `${sizeFixed} B`
    case 1:
      return `${sizeFixed} KB`
    case 2:
      return `${sizeFixed} MB`
    case 3:
      return `${sizeFixed} GB`
    case 4:
      return `${sizeFixed} TB`
    case 5:
      return `${sizeFixed} PB`
    default:
      return '档案巨大，奴婢承受不起'
  }
}
export function formatErrorKey (key) {
  switch (key) {
    case 'phone':
      return '手机格式错误'
    case 'input_password':
      return '密码长度6-16位'
    default:
      return null
  }
}
export const formatError = (e, defaultMsg = '未知错误') => {
  if (!e) {
    return e
  }
  if (typeof e === 'string') {
    return e
  }
  // if (e instanceof Error) {
  // }
  if (e.response) { // axios error
    let key = _.get(e, 'response.data.data.name')
    let formatted = formatErrorKey(key)
    if (formatted) {
      return formatted
    }
    return _.get(e, 'response.data.msg') || _.get(e, 'message') || defaultMsg
  }
  return e.errMsg || e.message || e.code || defaultMsg
}
export const formatUserModule = (list, config) => {
  let md0 = _.find(list, { type: 'preference' })
  let md1 = _.find(list, { type: 'case' })
  return [
    {
      id: _.get(md0, 'id'),
      type: 'md-list',
      name: '投资偏好',
      value: [
        {
          type: 'tag',
          name: '投资阶段',
          ref: 'stage',
          value: _.sortBy(_.get(md0, 'data.stage', []), item => {
            return config.stageSrc.indexOf(item)
          })
        },
        {
          type: 'tag',
          name: '投资领域',
          ref: 'industry',
          value: _.sortBy(_.get(md0, 'data.field', []), item => {
            return _.findIndex(config.industry, {value: item})
          })
        },
        {
          type: 'range',
          name: '单个项目投资金额',
          unit: 10000,
          value: _.get(md0, 'data.amount', [])
        }
      ]
    },
    {
      id: _.get(md1, 'id'),
      type: 'md-case',
      name: '投资案例',
      value: _.get(md1, 'data', []).map(row => {
        return {
          type: 'media',
          name: _.get(row, 'name'),
          value: _.get(row, 'desc'),
          label: _.get(row, 'industry'),
          logo: _.get(row, 'logo'),
          img: _.get(row, 'logo.url')
        }
      })
    }
  ]
}
export function buildUrl (rootDomain, key, entrypoint = '', params = null) {
  let qstr = ''
  if (params) {
    qstr = `?${qs.stringify(params)}`
  }
  switch (key) {
    case 'conf':
      return `https://static.thomas.nutsbp.${rootDomain}/nutsbp-config${entrypoint}${qstr}`
    case 'dcV2Graphql':
      return `https://dartcome.${rootDomain}/api/graphql`
    case 'ranch':
      return `https://api.ranch.nutsbp.${rootDomain}${entrypoint}${qstr}`
    case 'nutsbp':
      return `https://api.thomas.nutsbp.${rootDomain}${entrypoint}${qstr}`
    case 'nutsbpConf':
      return `https://static.thomas.nutsbp.com/nutsbp-config${entrypoint}${qstr}`
    case 'editor':
      return `https://bp.nutsbp.${rootDomain}${qstr}`
    case 'editorSignup':
      return `https://bp.nutsbp.${rootDomain}/signUp${qstr}`
    case 'editorForget':
      return `https://bp.nutsbp.${rootDomain}/Forget${qstr}`
    case 'editorPreview':
      return `https://editor.nutsbp.${rootDomain}/preview`
    case 'editorDownload':
      return `https://download.nutsbp.${rootDomain}${qstr}`
    default:
      return ''
  }
}

const regex = {
  weixin: /^([a-zA-Z][\w-]{5,19}|[1-9]\d{4,19})$/
}
export const pathToUserAccount = (path = '') => {
  let pre3 = path.substring(0, 3)
  if (pre3 !== '/p/' && pre3 !== '/u/') {
    return null
  }
  let match = path.substring(3).match(/^([a-zA-Z0-9-]+)/)
  return match ? match[0] : match
}
export const isWeixin = (weixin) => {
  if (!_.isString(weixin)) {
    return false
  }
  return regex.weixin.test(weixin)
}



// WEBPACK FOOTER //
// ./src/util.js